import type { NextPage } from "next";
import { withPageAuthRequired } from "@common/middleware";
import { MxWidgetType } from "@modules/mx/types";
import MxWidget from "@modules/mx/components/Widget";

const Budget = () => {
  return (
    <div className="flex flex-1 flex-col">
      <div className="offset-mobile-bottom-padding-hack flex flex-1">
        <MxWidget widgetType={MxWidgetType.budgets_widget} />
      </div>
    </div>
  );
};

export default withPageAuthRequired(Budget) as NextPage;
